module.exports = __webpack_public_path__ + "static/media/link_pre.e8dcbc92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/link_pre.png
// module id = 1396
// module chunks = 0